<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Header Section -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-blue-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-blue-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Gestión de Clientes
          <span class="px-2 sm:px-3 py-0.5 bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 text-xs sm:text-sm font-black rounded-lg border border-blue-200 dark:border-blue-800">
            {{ clientes.length }}
          </span>
        </h1>
      </div>
      <div class="flex items-center gap-2 w-full sm:w-auto flex-wrap justify-end">
        <!-- Botón WhatsApp -->
        <button
          v-if="selectedCliente && selectedCliente.telefono"
          @click="abrirWhatsappClienteSeleccionado()"
          class="px-3 sm:px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-md flex items-center gap-1 sm:gap-2"
        >
          <Icon icon="mdi:whatsapp" class="text-base sm:text-lg" />
          <span class="hidden sm:inline">WhatsApp</span>
        </button>

        <!-- Botón Exportar -->
        <div class="relative">
          <button
            @click="showExportMenu = !showExportMenu"
            class="px-3 sm:px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-md flex items-center gap-1 sm:gap-2"
          >
            <Icon icon="mdi:file-export" class="text-base sm:text-lg" />
            <span class="hidden sm:inline">Exportar</span>
            <span class="sm:hidden">Exp.</span>
            <Icon icon="mdi:chevron-down" class="text-base" />
          </button>
          
          <div v-if="showExportMenu" 
               class="absolute right-0 mt-2 w-48 sm:w-56 bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 z-50">
            <div class="py-2">
              <button @click="exportToExcel" class="w-full px-4 py-2.5 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs">
                <Icon icon="mdi:microsoft-excel" class="mr-3 text-green-600 text-lg" />
                <span>Exportar a Excel</span>
              </button>
              <button @click="exportEmpresasToExcel" class="w-full px-4 py-2.5 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs">
                <Icon icon="mdi:office-building" class="mr-3 text-green-600 text-lg" />
                <span>Exportar Empresas a Excel</span>
              </button>
              <button @click="exportEmpresasToPDF" class="w-full px-4 py-2.5 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs">
                <Icon icon="mdi:file-pdf-box" class="mr-3 text-red-600 text-lg" />
                <span>Exportar Empresas a PDF</span>
              </button>
              <button @click="exportToPDF" class="w-full px-4 py-2.5 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs">
                <Icon icon="mdi:file-pdf-box" class="mr-3 text-red-600 text-lg" />
                <span>Exportar a PDF</span>
              </button>
              <div class="border-t border-gray-200 dark:border-gray-700 my-2"></div>
              <button @click="exportFullReport" class="w-full px-4 py-2.5 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs">
                <Icon icon="mdi:file-multiple" class="mr-3 text-blue-600 text-lg" />
                <span>Reporte Completo</span>
              </button>
              <div class="border-t border-gray-200 dark:border-gray-700 my-2"></div>
              <button @click="triggerImportEmpresas" class="w-full px-4 py-2.5 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center text-gray-700 dark:text-gray-300 text-xs">
                <Icon icon="mdi:import" class="mr-3 text-blue-600 text-lg" />
                <span>Importar Empresas (RIF)</span>
              </button>
            </div>
          </div>
        </div>
        
        <!-- Vista Toggle -->
        <div class="flex bg-gray-100 dark:bg-gray-700 p-1 rounded-xl">
          <button @click="viewMode = 'table'" :class="['p-1.5 rounded-lg transition-all', viewMode === 'table' ? 'bg-white dark:bg-gray-600 shadow-sm text-blue-600' : 'text-gray-500']">
            <Icon icon="mdi:table" class="text-lg" />
          </button>
          <button @click="viewMode = 'cards'" :class="['p-1.5 rounded-lg transition-all', viewMode === 'cards' ? 'bg-white dark:bg-gray-600 shadow-sm text-blue-600' : 'text-gray-500']">
            <Icon icon="mdi:view-grid" class="text-lg" />
          </button>
        </div>
        
        <button @click="openCreateModal" class="px-3 sm:px-5 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-md flex items-center gap-1 sm:gap-2">
          <Icon icon="mdi:plus-circle" class="text-base sm:text-lg" />
          <span class="hidden sm:inline">Nuevo Cliente</span>
          <span class="sm:hidden">Nuevo</span>
        </button>
      </div>
    </div>

    <!-- Filtros y búsqueda -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-5 mb-3 sm:mb-5 animate-fadeInUp">
      <div class="grid grid-cols-1 sm:grid-cols-12 gap-3 sm:gap-5 items-end">
        <div class="sm:col-span-5 lg:col-span-6">
          <label class="block text-[10px] sm:text-[11px] font-black text-gray-400 tracking-widest mb-1 sm:mb-2 ml-1">Buscar Clientes</label>
          <div class="relative group">
            <Icon icon="mdi:magnify" class="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg sm:text-2xl group-focus-within:text-blue-500 transition-colors" />
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Documento, nombre, teléfono, email..."
              class="w-full pl-10 sm:pl-14 pr-3 sm:pr-4 py-2.5 sm:py-3 bg-gray-50 dark:bg-gray-900/50 border-2 border-gray-100 dark:border-gray-700 focus:border-blue-500 focus:bg-white dark:focus:bg-gray-700 rounded-xl transition-all duration-300 outline-none dark:text-white font-bold text-sm sm:text-base"
              @input="handleSearch"
            />
          </div>
        </div>
        
        <div class="sm:col-span-4 lg:col-span-3">
          <label class="block text-[10px] sm:text-[11px] font-black text-gray-400 tracking-widest mb-1 sm:mb-2 ml-1">Estado</label>
          <select
            v-model="filterStatus"
            @change="handleFilterChange"
            class="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-50 dark:bg-gray-900/50 border-2 border-gray-100 dark:border-gray-700 focus:border-blue-500 rounded-xl font-black text-gray-800 dark:text-white outline-none transition-all appearance-none cursor-pointer text-sm sm:text-base"
          >
            <option value="all">TODOS</option>
            <option value="activos">ACTIVOS</option>
            <option value="inactivos">INACTIVOS</option>
          </select>
        </div>

        <div class="sm:col-span-3 lg:col-span-3 flex gap-2">
          <select
            v-model="sortBy"
            class="flex-1 px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-50 dark:bg-gray-900/50 border-2 border-gray-100 dark:border-gray-700 focus:border-blue-500 rounded-xl font-black text-gray-800 dark:text-white outline-none transition-all appearance-none cursor-pointer text-sm sm:text-base"
          >
            <option value="nombre">Nombre (A-Z)</option>
            <option value="nombre_desc">Nombre (Z-A)</option>
            <option value="apellido">Apellido (A-Z)</option>
            <option value="documento">Documento</option>
            <option value="fechaCreacion_desc">Más recientes</option>
            <option value="fechaCreacion">Más antiguos</option>
          </select>
          <button @click="loadClientes" class="px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] sm:text-xs tracking-widest hover:bg-gray-200 transition-all flex items-center gap-1">
            <Icon icon="mdi:refresh" :class="{'animate-spin': loading}" />
            <span class="hidden sm:inline">Actualizar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Estadísticas Premium -->
    <div class="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 mb-3 sm:mb-5 animate-fadeInUp delay-100">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] font-black text-gray-400 tracking-widest uppercase">Total</p>
            <p class="text-xl sm:text-2xl font-black text-gray-900 dark:text-white">{{ clientes.length }}</p>
          </div>
          <div class="p-2 sm:p-3 bg-blue-50 dark:bg-blue-900/30 rounded-xl">
            <Icon icon="mdi:account-multiple" class="text-blue-600 dark:text-blue-400 text-xl sm:text-2xl" />
          </div>
        </div>
        <div class="mt-2 sm:mt-4">
          <span class="px-2 py-0.5 bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 rounded-full text-[8px] sm:text-[10px] font-black">
            {{ filteredClientes.length }} filtrados
          </span>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] font-black text-gray-400 tracking-widest uppercase">Activos</p>
            <p class="text-xl sm:text-2xl font-black text-emerald-600">{{ estadisticas.activos }}</p>
          </div>
          <div class="p-2 sm:p-3 bg-emerald-50 dark:bg-emerald-900/30 rounded-xl">
            <Icon icon="mdi:check-decagram" class="text-emerald-600 dark:text-emerald-400 text-xl sm:text-2xl" />
          </div>
        </div>
        <div class="mt-2 sm:mt-4">
          <div class="w-full bg-gray-100 dark:bg-gray-700 h-1.5 rounded-full overflow-hidden">
            <div class="bg-emerald-500 h-full rounded-full" :style="{ width: estadisticas.porcentajeActivos + '%' }"></div>
          </div>
          <span class="text-[8px] sm:text-[10px] font-bold text-gray-500 mt-1 block">{{ estadisticas.porcentajeActivos }}%</span>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] font-black text-gray-400 tracking-widest uppercase">Ventas</p>
            <p class="text-lg sm:text-2xl font-black text-indigo-600">{{ formatCurrency(estadisticas.totalVentas) }}</p>
          </div>
          <div class="p-2 sm:p-3 bg-indigo-50 dark:bg-indigo-900/30 rounded-xl">
            <Icon icon="mdi:currency-usd" class="text-indigo-600 dark:text-indigo-400 text-xl sm:text-2xl" />
          </div>
        </div>
        <div class="mt-2 sm:mt-4 text-[8px] sm:text-[10px] text-gray-500">
          <Icon icon="mdi:chart-line" class="inline mr-1 text-indigo-500" /> Total acumulado
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] font-black text-gray-400 tracking-widest uppercase">Servicios</p>
            <p class="text-xl sm:text-2xl font-black text-purple-600">{{ estadisticas.totalServicios }}</p>
          </div>
          <div class="p-2 sm:p-3 bg-purple-50 dark:bg-purple-900/30 rounded-xl">
            <Icon icon="mdi:wrench-clock" class="text-purple-600 dark:text-purple-400 text-xl sm:text-2xl" />
          </div>
        </div>
        <div class="mt-2 sm:mt-4 text-[8px] sm:text-[10px] text-gray-500">
          <Icon icon="mdi:history" class="inline mr-1 text-purple-500" /> Equipos recibidos
        </div>
      </div>
    </div>

    <!-- Data Table -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden animate-fadeInUp delay-200">
      <!-- Versión Desktop: Tabla -->
      <div class="hidden lg:block overflow-x-auto custom-scrollbar">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Cliente</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Documento</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Contacto</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Resumen</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-center">Estado</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-right">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            <tr v-if="loading" v-for="i in 5" :key="'load-'+i" class="animate-pulse">
              <td colspan="6" class="px-5 py-4"><div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full"></div></td>
            </tr>
            <tr v-if="!loading && filteredClientes.length === 0">
              <td colspan="6" class="px-5 py-16 text-center">
                <div class="flex flex-col items-center opacity-30 select-none">
                  <Icon icon="mdi:account-off-outline" class="text-7xl mb-3" />
                  <h4 class="text-xl font-black text-gray-400 tracking-widest">No hay clientes</h4>
                  <p class="text-sm text-gray-300 mt-1">Registra tu primer cliente</p>
                </div>
              </td>
            </tr>
            <tr v-for="cliente in paginatedClientes" :key="cliente.idCliente" class="hover:bg-blue-50/30 dark:hover:bg-gray-700/30 transition-all group">
              <td class="px-5 py-4">
                <div class="flex items-center">
                  <div class="flex-shrink-0 h-10 w-10">
                    <div :class="[
                      'h-10 w-10 rounded-xl flex items-center justify-center shadow-sm',
                      cliente.estado?.toLowerCase() === 'activo'
                        ? 'bg-gradient-to-br from-blue-100 to-indigo-100 dark:from-blue-900 dark:to-indigo-900'
                        : 'bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900'
                    ]">
                      <Icon icon="mdi:account" :class="[
                        'text-lg',
                        cliente.estado?.toLowerCase() === 'activo'
                          ? 'text-blue-600 dark:text-blue-400'
                          : 'text-gray-500 dark:text-gray-400'
                      ]" />
                    </div>
                  </div>
                  <div class="ml-3">
                    <div 
                      class="text-sm font-black text-gray-900 dark:text-white cursor-pointer hover:text-blue-600 transition-colors"
                      @click.stop="openDetailModal(cliente)"
                    >
                      {{ formatearNombreCompleto(cliente.nombre, cliente.apellido) }}
                    </div>
                    <div class="text-[10px] text-gray-500 dark:text-gray-400">ID: {{ cliente.idCliente }}</div>
                  </div>
                </div>
              </td>
              <td class="px-5 py-4">
                <div>
                  <span class="text-[10px] text-gray-500 dark:text-gray-400 block">{{ formatearTipoDocumento(cliente.tipoDocumento) }}</span>
                  <span class="text-xs font-bold text-gray-900 dark:text-white">{{ cliente.documento }}</span>
                </div>
              </td>
              <td class="px-5 py-4">
                <div class="space-y-1">
                  <div v-if="cliente.telefono" class="flex items-center text-xs text-gray-700 dark:text-gray-300">
                    <Icon icon="mdi:phone" class="mr-1.5 text-gray-400 text-xs" />
                    {{ cliente.telefono }}
                  </div>
                  <div v-if="cliente.email" class="flex items-center text-xs text-gray-700 dark:text-gray-300">
                    <Icon icon="mdi:email" class="mr-1.5 text-gray-400 text-xs" />
                    <span class="truncate max-w-[150px]">{{ cliente.email }}</span>
                  </div>
                </div>
              </td>
              <td class="px-5 py-4">
                <div class="flex flex-col space-y-1">
                  <div class="flex items-center text-xs font-black text-blue-600 dark:text-blue-400">
                    <Icon icon="mdi:cart" class="mr-1" />
                    {{ cliente.stats?.totalVentasCount || 0 }} Ventas
                  </div>
                  <div class="flex items-center text-xs font-black text-purple-600 dark:text-purple-400">
                    <Icon icon="mdi:tools" class="mr-1" />
                    {{ cliente.stats?.totalServiciosCount || 0 }} Serv.
                  </div>
                </div>
              </td>
              <td class="px-5 py-4 text-center">
                <span
                  @click.stop="abrirModalToggleStatus(cliente)"
                  :class="[
                    'px-3 py-1 inline-flex text-[10px] font-black uppercase tracking-widest rounded-lg shadow-sm cursor-pointer border',
                    cliente.estado?.toLowerCase() === 'activo'
                      ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800'
                      : 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-900/30 dark:text-rose-300 dark:border-rose-800'
                  ]"
                >
                  <Icon :icon="cliente.estado?.toLowerCase() === 'activo' ? 'mdi:check-circle' : 'mdi:close-circle'" class="mr-1.5 text-xs" />
                  {{ convertirEstadoATexto(cliente.estado) }}
                </span>
              </td>
              <td class="px-5 py-4 text-right">
                <div class="flex items-center justify-end gap-1 flex-nowrap">
                  <button v-if="cliente.telefono" @click.stop="abrirWhatsappCliente(cliente)" title="WhatsApp" class="p-1.5 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-lg hover:bg-green-600 hover:text-white transition-all shadow-sm">
                    <Icon icon="mdi:whatsapp" class="text-base" />
                  </button>
                  <button @click.stop="openDetailModal(cliente)" title="Ver detalles" class="p-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg hover:bg-blue-600 hover:text-white transition-all shadow-sm">
                    <Icon icon="mdi:eye" class="text-base" />
                  </button>
                  <button @click.stop="openEditModal(cliente)" title="Editar" class="p-1.5 bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 rounded-lg hover:bg-amber-600 hover:text-white transition-all shadow-sm">
                    <Icon icon="mdi:pencil" class="text-base" />
                  </button>
                  <button @click.stop="abrirModalToggleStatus(cliente)" :title="cliente.estado?.toLowerCase() === 'activo' ? 'Desactivar' : 'Activar'" class="p-1.5 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-lg hover:bg-indigo-600 hover:text-white transition-all shadow-sm">
                    <Icon :icon="cliente.estado?.toLowerCase() === 'activo' ? 'mdi:eye-off' : 'mdi:eye'" class="text-base" />
                  </button>
                  <button @click.stop="abrirModalEliminar(cliente)" title="Eliminar" class="p-1.5 bg-rose-50 dark:bg-rose-900/30 text-rose-600 dark:text-rose-400 rounded-lg hover:bg-rose-600 hover:text-white transition-all shadow-sm">
                    <Icon icon="mdi:delete" class="text-base" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Versión Mobile: Tarjetas -->
      <div class="lg:hidden space-y-3 p-2">
        <div v-if="loading" v-for="i in 3" :key="'load-mobile-'+i" class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 animate-pulse">
          <div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full mb-2"></div>
          <div class="h-3 bg-gray-100 dark:bg-gray-700 rounded w-3/4"></div>
        </div>
        
        <div v-if="!loading && filteredClientes.length === 0" class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-8 text-center">
          <div class="flex flex-col items-center opacity-30 select-none">
            <Icon icon="mdi:account-off-outline" class="text-6xl mb-3" />
            <h4 class="text-lg font-black text-gray-400 tracking-widest">No hay clientes</h4>
          </div>
        </div>
        
        <div v-for="cliente in paginatedClientes" :key="cliente.idCliente" 
             class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-all duration-200">
          
          <div class="flex items-center justify-between mb-3 pb-2 border-b border-gray-100 dark:border-gray-700">
            <div class="flex items-center gap-3">
              <div :class="[
                'w-10 h-10 rounded-xl flex items-center justify-center shadow-sm',
                cliente.estado?.toLowerCase() === 'activo'
                  ? 'bg-gradient-to-br from-blue-100 to-indigo-100 dark:from-blue-900 dark:to-indigo-900'
                  : 'bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900'
              ]">
                <Icon icon="mdi:account" :class="[
                  'text-lg',
                  cliente.estado?.toLowerCase() === 'activo'
                    ? 'text-blue-600 dark:text-blue-400'
                    : 'text-gray-500 dark:text-gray-400'
                ]" />
              </div>
              <div>
                <p 
                  class="font-black text-gray-900 dark:text-white text-sm cursor-pointer hover:text-blue-600 transition-colors"
                  @click.stop="openDetailModal(cliente)"
                >
                  {{ formatearNombreCompleto(cliente.nombre, cliente.apellido) }}
                </p>
                <p class="text-[10px] text-gray-500 dark:text-gray-400">ID: {{ cliente.idCliente }}</p>
              </div>
            </div>
            <span :class="[
              'px-2 py-0.5 text-[8px] font-black uppercase tracking-widest rounded-lg border',
              cliente.estado?.toLowerCase() === 'activo'
                ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800'
                : 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-900/30 dark:text-rose-300 dark:border-rose-800'
            ]">
              {{ convertirEstadoATexto(cliente.estado) }}
            </span>
          </div>

          <div class="grid grid-cols-2 gap-1 mb-2 text-xs">
            <div>
              <span class="text-gray-400 font-black text-[10px]">Documento</span>
              <p class="font-bold text-gray-800 dark:text-white">{{ cliente.documento }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-black text-[10px]">Tipo</span>
              <p class="font-bold text-gray-800 dark:text-white">{{ formatearTipoDocumento(cliente.tipoDocumento) }}</p>
            </div>
          </div>

          <div class="mb-2 text-xs">
            <div v-if="cliente.telefono" class="flex items-center text-gray-700 dark:text-gray-300">
              <Icon icon="mdi:phone" class="mr-1.5 text-gray-400" />
              {{ cliente.telefono }}
            </div>
            <div v-if="cliente.email" class="flex items-center text-gray-700 dark:text-gray-300">
              <Icon icon="mdi:email" class="mr-1.5 text-gray-400" />
              <span class="truncate">{{ cliente.email }}</span>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-2 mb-3 bg-gray-50 dark:bg-gray-900/30 rounded-xl p-2 text-center">
            <div>
              <p class="text-[8px] font-black text-gray-400 uppercase">Ventas</p>
              <p class="text-sm font-black text-blue-600">{{ cliente.stats?.totalVentasCount || 0 }}</p>
            </div>
            <div>
              <p class="text-[8px] font-black text-gray-400 uppercase">Servicios</p>
              <p class="text-sm font-black text-purple-600">{{ cliente.stats?.totalServiciosCount || 0 }}</p>
            </div>
          </div>

          <div class="flex flex-wrap items-center gap-1.5 pt-2 border-t border-gray-200 dark:border-gray-700">
            <button v-if="cliente.telefono" @click.stop="abrirWhatsappCliente(cliente)" title="WhatsApp" class="p-2 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-lg hover:bg-green-600 hover:text-white transition-all shadow-sm flex-1 sm:flex-none flex items-center justify-center gap-1">
              <Icon icon="mdi:whatsapp" class="text-sm" />
              <span class="text-[8px] font-black sm:hidden">WhatsApp</span>
            </button>
            <button @click.stop="openDetailModal(cliente)" title="Detalles" class="p-2 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg hover:bg-blue-600 hover:text-white transition-all shadow-sm flex-1 sm:flex-none flex items-center justify-center gap-1">
              <Icon icon="mdi:eye" class="text-sm" />
              <span class="text-[8px] font-black sm:hidden">Detalles</span>
            </button>
            <button @click.stop="openEditModal(cliente)" title="Editar" class="p-2 bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 rounded-lg hover:bg-amber-600 hover:text-white transition-all shadow-sm flex-1 sm:flex-none flex items-center justify-center gap-1">
              <Icon icon="mdi:pencil" class="text-sm" />
              <span class="text-[8px] font-black sm:hidden">Editar</span>
            </button>
            <button @click.stop="abrirModalToggleStatus(cliente)" :title="cliente.estado?.toLowerCase() === 'activo' ? 'Desactivar' : 'Activar'" class="p-2 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-lg hover:bg-indigo-600 hover:text-white transition-all shadow-sm flex-1 sm:flex-none flex items-center justify-center gap-1">
              <Icon :icon="cliente.estado?.toLowerCase() === 'activo' ? 'mdi:eye-off' : 'mdi:eye'" class="text-sm" />
              <span class="text-[8px] font-black sm:hidden">{{ cliente.estado?.toLowerCase() === 'activo' ? 'Desactivar' : 'Activar' }}</span>
            </button>
            <button @click.stop="abrirModalEliminar(cliente)" title="Eliminar" class="p-2 bg-rose-50 dark:bg-rose-900/30 text-rose-600 dark:text-rose-400 rounded-lg hover:bg-rose-600 hover:text-white transition-all shadow-sm flex-1 sm:flex-none flex items-center justify-center gap-1">
              <Icon icon="mdi:delete" class="text-sm" />
              <span class="text-[8px] font-black sm:hidden">Eliminar</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div v-if="filteredClientes.length > 0 && !loading" class="bg-gray-50/50 dark:bg-gray-800/50 px-3 sm:px-5 py-3 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div class="text-[10px] sm:text-[11px] font-black text-gray-400 uppercase tracking-widest text-center sm:text-left">
          MOSTRANDO {{ startItem }} - {{ endItem }} DE {{ filteredClientes.length }}
        </div>
        <div class="flex items-center gap-1 flex-wrap justify-center">
          <button @click="currentPage = Math.max(currentPage - 1, 1)" :disabled="currentPage === 1" :class="['p-1.5 rounded-lg border transition-all', currentPage === 1 ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
            <Icon icon="mdi:chevron-left" class="text-base sm:text-2xl" />
          </button>
          <div class="hidden sm:flex items-center gap-0.5 sm:gap-1 mx-1 sm:mx-2">
            <button v-for="page in visiblePages" :key="page" @click="currentPage = page" :class="['w-7 h-7 sm:w-9 sm:h-9 rounded-lg text-[10px] sm:text-xs font-black transition-all flex items-center justify-center', currentPage === page ? 'bg-blue-600 text-white shadow-md shadow-blue-500/30' : 'text-gray-500 hover:bg-white dark:hover:bg-gray-700 border border-transparent hover:border-gray-200 dark:hover:border-gray-600']">
              {{ page }}
            </button>
          </div>
          <span class="sm:hidden text-xs font-black text-gray-600 dark:text-gray-300 px-2">{{ currentPage }} / {{ totalPages }}</span>
          <button @click="currentPage = Math.min(currentPage + 1, totalPages)" :disabled="currentPage === totalPages" :class="['p-1.5 rounded-lg border transition-all', currentPage === totalPages ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
            <Icon icon="mdi:chevron-right" class="text-base sm:text-2xl" />
          </button>
        </div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- MODAL FORMULARIO -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="showModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9998]" @click.self="showModal = false">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden animate-zoomIn">
          <div class="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 sm:px-6 py-4 flex items-center gap-3 sticky top-0 z-10">
            <div class="p-2 bg-white/20 rounded-xl">
              <Icon :icon="editingCliente ? 'mdi:pencil-box' : 'mdi:account-plus'" class="text-white text-xl" />
            </div>
            <div>
              <h3 class="text-sm font-black text-white">{{ editingCliente ? 'Editar Cliente' : 'Nuevo Cliente' }}</h3>
              <p class="text-[10px] text-white/70 font-bold">{{ editingCliente ? 'Modifica los datos' : 'Completa los datos' }}</p>
            </div>
            <button @click="closeModal" class="ml-auto p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg" />
            </button>
          </div>
          <div class="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
            <form @submit.prevent="saveCliente" class="space-y-5">
              <!-- Tipo de Documento y Documento -->
              <div class="bg-gray-50 dark:bg-gray-900/30 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label class="block text-[10px] font-black text-gray-400 tracking-widest mb-2">Tipo de Documento *</label>
                    <select v-model="form.tipoDocumento" required @change="handleTipoDocumentoChange" class="w-full px-3 sm:px-4 py-2.5 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 focus:border-blue-500 rounded-xl text-xs font-black text-gray-800 dark:text-white outline-none transition-all appearance-none cursor-pointer">
                      <option value="cedula">Cédula Venezolana</option>
                      <option value="rif">RIF</option>
                      <option value="pasaporte">Pasaporte</option>
                      <option value="identificacion_extranjera">Identificación Extranjera</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-[10px] font-black text-gray-400 tracking-widest mb-2">Número de Documento *</label>
                    <input v-model="form.documento" type="text" required :maxlength="getMaxLengthDocumento()" class="w-full px-3 sm:px-4 py-2.5 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 focus:border-blue-500 rounded-xl text-xs font-medium text-gray-800 dark:text-white outline-none transition-all" :placeholder="getPlaceholderDocumento()" @input="formatearDocumentoInput" />
                  </div>
                </div>
              </div>

              <!-- Nombre y Apellido -->
              <div class="bg-gray-50 dark:bg-gray-900/30 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label class="block text-[10px] font-black text-gray-400 tracking-widest mb-2">Nombre *</label>
                    <input v-model="form.nombre" type="text" required maxlength="100" class="w-full px-3 sm:px-4 py-2.5 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 focus:border-blue-500 rounded-xl text-xs font-medium text-gray-800 dark:text-white outline-none transition-all" placeholder="Nombre(s)" />
                  </div>
                  <div>
                    <label class="block text-[10px] font-black text-gray-400 tracking-widest mb-2">Apellido</label>
                    <input v-model="form.apellido" type="text" maxlength="100" class="w-full px-3 sm:px-4 py-2.5 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 focus:border-blue-500 rounded-xl text-xs font-medium text-gray-800 dark:text-white outline-none transition-all" placeholder="Apellido(s)" />
                  </div>
                </div>
              </div>

              <!-- Teléfono y Email -->
              <div class="bg-gray-50 dark:bg-gray-900/30 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label class="block text-[10px] font-black text-gray-400 tracking-widest mb-2">Teléfono</label>
                    <input v-model="form.telefono" type="tel" maxlength="15" class="w-full px-3 sm:px-4 py-2.5 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 focus:border-blue-500 rounded-xl text-xs font-medium text-gray-800 dark:text-white outline-none transition-all" placeholder="Ej: 0416-7470715" @input="formatearTelefono" />
                  </div>
                  <div>
                    <label class="block text-[10px] font-black text-gray-400 tracking-widest mb-2">Email</label>
                    <input v-model="form.email" type="email" maxlength="100" class="w-full px-3 sm:px-4 py-2.5 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 focus:border-blue-500 rounded-xl text-xs font-medium text-gray-800 dark:text-white outline-none transition-all" placeholder="cliente@ejemplo.com" />
                  </div>
                </div>
              </div>

              <!-- Dirección -->
              <div class="bg-gray-50 dark:bg-gray-900/30 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                <label class="block text-[10px] font-black text-gray-400 tracking-widest mb-2">Dirección</label>
                <textarea v-model="form.direccion" rows="2" maxlength="200" class="w-full px-3 sm:px-4 py-2.5 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 focus:border-blue-500 rounded-xl text-xs font-medium text-gray-800 dark:text-white outline-none transition-all resize-none" placeholder="Dirección completa"></textarea>
              </div>

              <!-- Estado -->
              <div class="bg-gray-50 dark:bg-gray-900/30 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                <label class="block text-[10px] font-black text-gray-400 tracking-widest mb-2">Estado</label>
                <div class="flex gap-4">
                  <label class="flex items-center gap-2 text-xs font-bold text-gray-700 dark:text-gray-300">
                    <input type="radio" v-model="form.estado" value="activo" class="w-4 h-4 text-blue-600" /> Activo
                  </label>
                  <label class="flex items-center gap-2 text-xs font-bold text-gray-700 dark:text-gray-300">
                    <input type="radio" v-model="form.estado" value="inactivo" class="w-4 h-4 text-blue-600" /> Inactivo
                  </label>
                </div>
              </div>

              <!-- Botones -->
              <div class="flex flex-col sm:flex-row gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
                <button type="button" @click="closeModal" class="w-full sm:flex-1 py-3 border-2 border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 rounded-xl font-black text-xs tracking-widest hover:bg-gray-50 dark:hover:bg-gray-700 transition-all">Cancelar</button>
                <button type="submit" :disabled="saving" class="w-full sm:flex-[2] py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-black text-xs uppercase tracking-widest hover:opacity-90 transition-all shadow-lg shadow-blue-500/30 disabled:opacity-50 flex items-center justify-center gap-2">
                  <Icon :icon="saving ? 'mdi:loading' : 'mdi:content-save'" :class="{'animate-spin': saving}" />
                  {{ saving ? 'Guardando...' : (editingCliente ? 'Actualizar Cliente' : 'Crear Cliente') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE DETALLES DEL CLIENTE -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="showDetailModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]" @click.self="closeDetailModal">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden animate-zoomIn">
          <!-- Encabezado -->
          <div class="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 sm:px-6 py-4 flex items-center gap-3 sticky top-0 z-10">
            <div class="p-2 bg-white/20 rounded-xl">
              <Icon icon="mdi:account-details" class="text-white text-xl" />
            </div>
            <div class="flex-1">
              <h3 class="text-sm font-black text-white">Expediente del Cliente</h3>
              <p class="text-[10px] text-white/70 font-bold">{{ selectedCliente ? formatearNombreCompleto(selectedCliente.nombre, selectedCliente.apellido) : '' }}</p>
            </div>
            <button @click="closeDetailModal" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg" />
            </button>
          </div>

          <!-- Botón WhatsApp en modal -->
          <div v-if="selectedCliente && selectedCliente.telefono" class="px-4 sm:px-6 py-2 bg-green-50 dark:bg-green-900/20 border-b border-gray-200 dark:border-gray-700 flex justify-end">
            <button @click="abrirWhatsappCliente(selectedCliente)" class="flex items-center px-3 sm:px-4 py-1.5 sm:py-2 bg-green-600 hover:bg-green-700 text-white rounded-xl font-black text-[10px] sm:text-xs transition-all shadow-md">
              <Icon icon="mdi:whatsapp" class="mr-2 text-base" />
              Enviar WhatsApp
            </button>
          </div>

          <!-- Tabs -->
          <div class="flex px-4 sm:px-6 border-b border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50">
            <button @click="activeDetailTab = 'general'" :class="['px-3 sm:px-4 py-2.5 sm:py-3 text-[10px] sm:text-xs font-black transition-all border-b-2 flex items-center gap-1 sm:gap-2', activeDetailTab === 'general' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700']">
              <Icon icon="mdi:account-circle" class="text-base" />
              General
            </button>
            <button @click="activeDetailTab = 'ventas'" :class="['px-3 sm:px-4 py-2.5 sm:py-3 text-[10px] sm:text-xs font-black transition-all border-b-2 flex items-center gap-1 sm:gap-2', activeDetailTab === 'ventas' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700']">
              <Icon icon="mdi:cart" class="text-base" />
              Ventas
              <span v-if="selectedClientVentas.length" class="px-1.5 py-0.5 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-full text-[8px]">{{ selectedClientVentas.length }}</span>
            </button>
            <button @click="activeDetailTab = 'servicios'" :class="['px-3 sm:px-4 py-2.5 sm:py-3 text-[10px] sm:text-xs font-black transition-all border-b-2 flex items-center gap-1 sm:gap-2', activeDetailTab === 'servicios' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700']">
              <Icon icon="mdi:tools" class="text-base" />
              Servicios
              <span v-if="selectedClientServicios.length" class="px-1.5 py-0.5 bg-purple-100 dark:bg-purple-900 text-purple-700 dark:text-purple-300 rounded-full text-[8px]">{{ selectedClientServicios.length }}</span>
            </button>
          </div>

          <!-- Contenido -->
          <div v-if="selectedCliente" class="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
            <!-- TAB: GENERAL -->
            <div v-if="activeDetailTab === 'general'" class="space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="space-y-4">
                  <div class="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-2xl border border-gray-200 dark:border-gray-700">
                    <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">Identificación</p>
                    <p class="text-[10px] text-gray-500">{{ formatearTipoDocumento(selectedCliente.tipoDocumento) }}</p>
                    <p class="text-lg font-black text-gray-900 dark:text-white">{{ selectedCliente.documento }}</p>
                  </div>
                  <div v-if="selectedCliente.telefono || selectedCliente.email" class="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-2xl border border-gray-200 dark:border-gray-700">
                    <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2">Contacto</p>
                    <div v-if="selectedCliente.telefono" class="flex items-center gap-2 text-sm font-black text-gray-900 dark:text-white">
                      <Icon icon="mdi:phone" class="text-green-600" /> {{ selectedCliente.telefono }}
                    </div>
                    <div v-if="selectedCliente.email" class="flex items-center gap-2 text-sm font-black text-gray-900 dark:text-white">
                      <Icon icon="mdi:email" class="text-amber-600" /> {{ selectedCliente.email }}
                    </div>
                  </div>
                </div>
                <div class="space-y-4">
                  <div v-if="selectedCliente.direccion" class="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-2xl border border-gray-200 dark:border-gray-700">
                    <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">Dirección</p>
                    <p class="text-sm font-bold text-gray-900 dark:text-white">{{ selectedCliente.direccion }}</p>
                  </div>
                  <div class="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-2xl border border-gray-200 dark:border-gray-700">
                    <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">Registro</p>
                    <p class="text-sm font-black text-gray-900 dark:text-white">{{ formatDate(selectedCliente.fechaCreacion) }}</p>
                    <p class="text-[10px] text-gray-500">{{ formatTime(selectedCliente.fechaCreacion) }}</p>
                  </div>
                </div>
              </div>

              <!-- Resumen Stats -->
              <div class="bg-gray-50 dark:bg-gray-900/50 rounded-2xl border border-gray-200 dark:border-gray-800 p-4">
                <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-3">Resumen de Actividad</p>
                <div class="grid grid-cols-3 gap-4">
                  <div>
                    <p class="text-[9px] font-black text-gray-400 uppercase">Ventas</p>
                    <p class="text-lg font-black text-blue-600">{{ selectedCliente?.stats?.totalVentasCount || 0 }}</p>
                  </div>
                  <div>
                    <p class="text-[9px] font-black text-gray-400 uppercase">Servicios</p>
                    <p class="text-lg font-black text-purple-600">{{ selectedCliente?.stats?.totalServiciosCount || 0 }}</p>
                  </div>
                  <div>
                    <p class="text-[9px] font-black text-gray-400 uppercase">Inversión</p>
                    <p class="text-lg font-black text-emerald-600">{{ formatCurrency(selectedCliente?.stats?.totalVentasMonto || 0) }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- TAB: VENTAS -->
            <div v-if="activeDetailTab === 'ventas'" class="animate-in fade-in slide-in-from-bottom-2 duration-300">
              <div v-if="loadingDetails" class="flex justify-center py-10">
                <div class="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600"></div>
              </div>
              <div v-else-if="selectedClientVentas.length === 0" class="text-center py-10">
                <Icon icon="mdi:cart-off" class="text-4xl text-gray-300 mx-auto mb-2" />
                <p class="text-sm text-gray-500">Sin historial de ventas</p>
              </div>
              <div v-else class="overflow-x-auto">
                <table class="w-full text-left text-xs">
                  <thead class="bg-gray-50 dark:bg-gray-700/50">
                    <tr>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase">Factura</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase">Productos</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase text-center">Modalidad</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase text-right">Monto</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase text-center">Estado</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                    <tr v-for="venta in selectedClientVentas" :key="venta.idVenta" @click="irAVenta(venta.idVenta)" class="hover:bg-blue-50/30 cursor-pointer transition-colors">
                      <td class="px-3 py-2 font-black">{{ venta.numeroFactura || 'S/N' }}</td>
                      <td class="px-3 py-2 text-gray-600 truncate max-w-[200px]">{{ venta.productos || 'Venta general' }}</td>
                      <td class="px-3 py-2 text-center"><span :class="['px-2 py-0.5 rounded-lg text-[8px] font-black uppercase', venta.tipoVenta === 'credito' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700']">{{ venta.tipoVenta }}</span></td>
                      <td class="px-3 py-2 text-right font-black text-emerald-600">{{ formatCurrency(venta.totalUsd) }}</td>
                      <td class="px-3 py-2 text-center"><span :class="['px-2 py-0.5 rounded-lg text-[8px] font-black uppercase', venta.estado === 'completada' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700']">{{ venta.estado }}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- TAB: SERVICIOS -->
            <div v-if="activeDetailTab === 'servicios'" class="animate-in fade-in slide-in-from-bottom-2 duration-300">
              <div v-if="loadingDetails" class="flex justify-center py-10">
                <div class="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-purple-600"></div>
              </div>
              <div v-else-if="selectedClientServicios.length === 0" class="text-center py-10">
                <Icon icon="mdi:tools-off" class="text-4xl text-gray-300 mx-auto mb-2" />
                <p class="text-sm text-gray-500">Sin registros de servicios</p>
              </div>
              <div v-else class="overflow-x-auto">
                <table class="w-full text-left text-xs">
                  <thead class="bg-gray-50 dark:bg-gray-700/50">
                    <tr>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase">Orden</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase">Equipo</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase text-right">Total</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase text-center">Estado</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                    <tr v-for="servicio in selectedClientServicios" :key="servicio.idRecepcionEquipo" @click="irAServicio(servicio.idRecepcionEquipo)" class="hover:bg-purple-50/30 cursor-pointer transition-colors">
                      <td class="px-3 py-2 font-black">#{{ servicio.numeroOrden }}</td>
                      <td class="px-3 py-2 text-gray-600 truncate max-w-[200px]">{{ servicio.problema }}</td>
                      <td class="px-3 py-2 text-right font-black text-purple-600">{{ formatCurrency(servicio.precioTotalUsd || 0) }}</td>
                      <td class="px-3 py-2 text-center"><span class="px-2 py-0.5 rounded-lg text-[8px] font-black uppercase bg-indigo-100 text-indigo-700">{{ servicio.nombreEstado || 'Activo' }}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="px-4 sm:px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-900/50 flex flex-col sm:flex-row gap-3">
            <button @click="closeDetailModal" class="w-full sm:flex-1 py-3 border-2 border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 rounded-xl font-black text-xs tracking-widest hover:bg-gray-100 transition-all">Cerrar</button>
            <button @click="openEditModal(selectedCliente); closeDetailModal()" class="w-full sm:flex-1 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-black text-xs uppercase tracking-widest hover:opacity-90 transition-all shadow-lg shadow-blue-500/30 flex items-center justify-center gap-2">
              <Icon icon="mdi:pencil" /> Editar Cliente
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE DETALLE DE VENTA -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="showVentaDetailModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[10000]" @click.self="showVentaDetailModal = false">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden animate-zoomIn">
          <div class="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 sm:px-6 py-4 flex items-center gap-3 sticky top-0 z-10">
            <div class="p-2 bg-white/20 rounded-xl">
              <Icon icon="mdi:receipt-text" class="text-white text-xl" />
            </div>
            <div class="flex-1">
              <h3 class="text-sm font-black text-white">{{ loadingVentaDetail ? 'Cargando...' : (selectedVentaDetail?.numeroFactura || 'Detalle de Factura') }}</h3>
              <p class="text-[10px] text-white/70 font-bold">{{ loadingVentaDetail ? 'Obteniendo información...' : formatDate(selectedVentaDetail?.fechaVenta) }}</p>
            </div>
            <button @click="showVentaDetailModal = false" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg" />
            </button>
          </div>

          <div class="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
            <div v-if="loadingVentaDetail" class="flex justify-center py-10">
              <div class="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600"></div>
            </div>
            <div v-else-if="selectedVentaDetail" class="space-y-4">
              <!-- Resumen -->
              <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
                <div class="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl text-center">
                  <p class="text-[9px] font-black text-blue-500 uppercase">Total USD</p>
                  <p class="text-lg font-black text-blue-600">{{ formatCurrency(selectedVentaDetail.totalUsd) }}</p>
                </div>
                <div class="p-3 bg-green-50 dark:bg-green-900/20 rounded-xl text-center">
                  <p class="text-[9px] font-black text-green-500 uppercase">Estado</p>
                  <p class="text-xs font-black text-green-600 uppercase">{{ selectedVentaDetail.estado }}</p>
                </div>
                <div class="p-3 bg-purple-50 dark:bg-purple-900/20 rounded-xl text-center">
                  <p class="text-[9px] font-black text-purple-500 uppercase">Modalidad</p>
                  <p class="text-xs font-black text-purple-600 uppercase">{{ selectedVentaDetail.tipoVenta }}</p>
                </div>
                <div class="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-xl text-center">
                  <p class="text-[9px] font-black text-amber-500 uppercase">Cliente</p>
                  <p class="text-xs font-black text-amber-700 truncate">{{ selectedVentaDetail.clienteNombre }}</p>
                </div>
              </div>

              <!-- Productos -->
              <div class="overflow-x-auto">
                <table class="w-full text-left text-xs">
                  <thead class="bg-gray-50 dark:bg-gray-700/50">
                    <tr>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase">Producto</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase text-center">Cant.</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase text-right">Precio</th>
                      <th class="px-3 py-2 font-black text-gray-400 uppercase text-right">Subtotal</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                    <tr v-for="detalle in selectedVentaDetail.detalles" :key="detalle.idVentaDetalle">
                      <td class="px-3 py-2 font-bold">{{ detalle.nombreProducto || detalle.productoNombre }}</td>
                      <td class="px-3 py-2 text-center">{{ detalle.cantidad }}</td>
                      <td class="px-3 py-2 text-right">{{ formatCurrency(detalle.precioUnitarioUsd) }}</td>
                      <td class="px-3 py-2 text-right font-black text-blue-600">{{ formatCurrency(detalle.subtotalUsd) }}</td>
                    </tr>
                  </tbody>
                  <tfoot class="bg-gray-50 dark:bg-gray-700/50">
                    <tr>
                      <td colspan="3" class="px-3 py-2 text-right font-black">Total</td>
                      <td class="px-3 py-2 text-right font-black text-blue-600">{{ formatCurrency(selectedVentaDetail.totalUsd) }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>

          <div class="px-4 sm:px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-900/50 flex justify-end">
            <button @click="showVentaDetailModal = false" class="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-black text-xs uppercase tracking-widest hover:opacity-90 transition-all shadow-lg shadow-blue-500/30">Cerrar</button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE DETALLE DE SERVICIO -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="showServicioDetailModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[10001]" @click.self="showServicioDetailModal = false">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden animate-zoomIn">
          <div class="bg-gradient-to-r from-green-600 to-emerald-700 px-4 sm:px-6 py-4 flex items-center gap-3 sticky top-0 z-10">
            <div class="p-2 bg-white/20 rounded-xl">
              <Icon icon="mdi:wrench-clock" class="text-white text-xl" />
            </div>
            <div class="flex-1">
              <h3 class="text-sm font-black text-white">{{ loadingServicioDetail ? 'Cargando...' : `Orden #${selectedServicioDetail?.numeroOrden || 'Detalles'}` }}</h3>
              <p class="text-[10px] text-white/70 font-bold">{{ loadingServicioDetail ? 'Obteniendo información...' : (selectedServicioDetail?.nombreEstado || 'Activo') }}</p>
            </div>
            <button @click="showServicioDetailModal = false" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg" />
            </button>
          </div>

          <div class="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
            <div v-if="loadingServicioDetail" class="flex justify-center py-10">
              <div class="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-green-600"></div>
            </div>
            <div v-else-if="selectedServicioDetail" class="space-y-4">
              <!-- Info General -->
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div class="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-xl">
                  <p class="text-[9px] font-black text-gray-400 uppercase">Equipo</p>
                  <p class="text-sm font-black text-gray-900 dark:text-white">{{ selectedServicioDetail.descripcion || 'N/A' }}</p>
                </div>
                <div class="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-xl">
                  <p class="text-[9px] font-black text-gray-400 uppercase">Problema</p>
                  <p class="text-sm font-black text-gray-900 dark:text-white">{{ selectedServicioDetail.problema || 'N/A' }}</p>
                </div>
                <div class="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-xl">
                  <p class="text-[9px] font-black text-gray-400 uppercase">Sede</p>
                  <p class="text-sm font-black text-gray-900 dark:text-white">{{ selectedServicioDetail.nombreSede || 'Central' }}</p>
                </div>
              </div>

              <!-- Técnicos -->
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div class="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl">
                  <p class="text-[9px] font-black text-blue-500 uppercase">Recibido por</p>
                  <p class="text-sm font-black text-gray-900 dark:text-white">{{ selectedServicioDetail.nombreTecnicoRecepcion || 'N/A' }}</p>
                </div>
                <div class="p-3 bg-purple-50 dark:bg-purple-900/20 rounded-xl">
                  <p class="text-[9px] font-black text-purple-500 uppercase">Técnico asignado</p>
                  <p class="text-sm font-black text-gray-900 dark:text-white">{{ selectedServicioDetail.nombreTecnicoReparador || 'Pendiente' }}</p>
                </div>
                <div class="p-3 bg-green-50 dark:bg-green-900/20 rounded-xl">
                  <p class="text-[9px] font-black text-green-500 uppercase">Entregado por</p>
                  <p class="text-sm font-black text-gray-900 dark:text-white">{{ selectedServicioDetail.nombreTecnicoEntrega || 'No entregado' }}</p>
                </div>
              </div>

              <!-- Totales -->
              <div class="grid grid-cols-2 sm:grid-cols-3 gap-3">
                <div class="p-3 bg-emerald-50 dark:bg-emerald-900/20 rounded-xl text-center">
                  <p class="text-[9px] font-black text-emerald-500 uppercase">Total USD</p>
                  <p class="text-lg font-black text-emerald-600">{{ formatCurrency(selectedServicioDetail.precioTotalUsd || 0) }}</p>
                </div>
                <div class="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-xl text-center">
                  <p class="text-[9px] font-black text-amber-500 uppercase">Diagnóstico</p>
                  <p class="text-xs font-black text-amber-600">{{ selectedServicioDetail.tipoDiagnostico || 'GRATIS' }}</p>
                </div>
                <div class="p-3 bg-indigo-50 dark:bg-indigo-900/20 rounded-xl text-center">
                  <p class="text-[9px] font-black text-indigo-500 uppercase">Accesorios</p>
                  <p class="text-xs font-black text-indigo-600">{{ selectedServicioDetail.accesorios || 'Ninguno' }}</p>
                </div>
              </div>

              <!-- Actividades -->
              <div v-if="selectedServicioDetail.actividadesRealizadas" class="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-2xl border border-gray-200 dark:border-gray-700">
                <p class="text-[9px] font-black text-gray-400 uppercase mb-1">Actividades Realizadas</p>
                <p class="text-sm text-gray-700 dark:text-gray-300">{{ selectedServicioDetail.actividadesRealizadas }}</p>
              </div>

              <!-- Repuestos -->
              <div v-if="selectedServicioDetail.repuestos" class="p-4 bg-orange-50 dark:bg-orange-900/20 rounded-2xl border border-orange-200 dark:border-orange-800/30">
                <p class="text-[9px] font-black text-orange-500 uppercase mb-1">Repuestos Utilizados</p>
                <p class="text-sm font-bold text-gray-800 dark:text-white">{{ selectedServicioDetail.repuestos }}</p>
              </div>
            </div>
          </div>

          <div class="px-4 sm:px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-900/50 flex justify-end">
            <button @click="showServicioDetailModal = false" class="px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl font-black text-xs uppercase tracking-widest hover:opacity-90 transition-all shadow-lg shadow-green-500/30">Cerrar</button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE CONFIRMACIÓN -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="showConfirmModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[10002]" @click.self="cancelarConfirmacion">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-zoomIn">
          <div class="px-4 sm:px-6 py-4" :class="confirmModalColor">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-white/20 rounded-xl">
                <Icon :icon="confirmModalIcon" class="text-white text-xl" />
              </div>
              <div>
                <h3 class="text-sm font-black text-white">{{ confirmModalTitulo }}</h3>
                <p class="text-[10px] text-white/80">{{ confirmModalSubtitulo }}</p>
              </div>
            </div>
          </div>
          <div class="p-4 sm:p-6">
            <p class="text-sm text-gray-700 dark:text-gray-300">{{ confirmModalMensaje }}</p>
            <p v-if="confirmModalDetalle" class="text-xs text-gray-500 dark:text-gray-400 mt-2">{{ confirmModalDetalle }}</p>
          </div>
          <div class="px-4 sm:px-6 py-4 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row gap-3">
            <button @click="cancelarConfirmacion" class="w-full sm:flex-1 py-3 border-2 border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 rounded-xl font-black text-xs tracking-widest hover:bg-gray-100 transition-all">Cancelar</button>
            <button @click="ejecutarAccionConfirmada" :disabled="confirmModalCargando" class="w-full sm:flex-[2] py-3 rounded-xl font-black text-xs uppercase tracking-widest hover:opacity-90 transition-all flex items-center justify-center gap-2" :class="confirmModalButtonColor">
              <Icon :icon="confirmModalCargando ? 'mdi:loading' : 'mdi:check'" :class="{'animate-spin': confirmModalCargando}" />
              {{ confirmModalCargando ? 'Procesando...' : confirmModalBotonTexto }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- input hidden para importaciones -->
    <input ref="importFile" type="file" accept=".xlsx,.xls,.csv" @change="handleImportFile" style="display:none" />
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { debounce } from 'lodash';

import {
  obtenerClientes,
  buscarClientesPorTermino,
  obtenerClientesActivos,
  obtenerClientesPorEstado,
  obtenerClientePorId,
  obtenerClienteConRelaciones,
  verificarClientePorDocumento,
  verificarClientePorId,
  crearCliente,
  actualizarCliente,
  eliminarCliente,
  activarCliente,
  desactivarCliente,
  cambiarEstadoCliente,
  buscarClientes,
  filtrarClientesPorEstado,
  obtenerEstadisticasClientes,
  ordenarClientes,
  exportarExcel,
  exportarPDF,
  exportarReporteCompleto,
  formatearTipoDocumento,
  convertirEstadoATexto,
  validarEmail,
  validarTelefono,
  validarDocumento,
  formatearCedulaVenezolana,
  formatearRIFVenezolano,
  formatearTelefonoVenezolano,
  obtenerInfoPrefijo,
  formatearNombreCompleto,
  TIPOS_DOCUMENTO,
  PREFIJOS_TELEFONO
} from '@/api/clientes.js';

import { toTitleCase } from '@/utils/stringUtils.js';
import { notificarCliente } from '@/utils/notificacionesHelper';
import { obtenerVentasPorCliente, obtenerVentaConRelaciones } from '@/api/ventas.js';
import { obtenerRecepcionesPorCliente, obtenerRecepcionConRelaciones } from '@/api/recepcionEquipo.js';

export default {
  name: 'ClientesList',
  components: { Icon },
  data() {
    return {
      clientes: [],
      loading: false,
      saving: false,
      showModal: false,
      showDetailModal: false,
      showExportMenu: false,
      searchQuery: '',
      filterStatus: 'all',
      sortBy: 'nombre',
      currentPage: 1,
      itemsPerPage: 10,
      viewMode: 'table',
      loadingStats: false,
      loadingDetails: false,
      selectedClientVentas: [],
      selectedClientServicios: [],
      activeDetailTab: 'general',
      form: {
        idCliente: null,
        tipoDocumento: 'cedula',
        documento: '',
        nombre: '',
        apellido: '',
        telefono: '',
        email: '',
        direccion: '',
        estado: 'activo',
      },
      errors: {},
      editingCliente: null,
      selectedCliente: null,
      lastUpdate: new Date(),

      // Confirmación
      showConfirmModal: false,
      confirmModalTipo: '',
      confirmModalTitulo: '',
      confirmModalSubtitulo: '',
      confirmModalMensaje: '',
      confirmModalDetalle: '',
      confirmModalIcon: '',
      confirmModalColor: '',
      confirmModalButtonColor: '',
      confirmModalBotonTexto: '',
      confirmModalCliente: null,
      confirmModalCargando: false,
      confirmModalAccion: null,
      confirmModalDatos: null,

      // Ventas y Servicios Detail
      showVentaDetailModal: false,
      showServicioDetailModal: false,
      loadingVentaDetail: false,
      loadingServicioDetail: false,
      selectedVentaDetail: null,
      selectedServicioDetail: null,
      activeVentaTab: 'resumen',
    };
  },
  computed: {
    filteredClientes() {
      let filtered = [...this.clientes];
      if (this.searchQuery.trim()) {
        filtered = buscarClientes(filtered, this.searchQuery);
      }
      filtered = filtrarClientesPorEstado(filtered, this.filterStatus);
      filtered = ordenarClientes(filtered, this.sortBy);
      return filtered;
    },
    estadisticas() {
      return obtenerEstadisticasClientes(this.clientes);
    },
    paginatedClientes() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredClientes.slice(start, start + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredClientes.length / this.itemsPerPage);
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);
      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },
    startItem() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    endItem() {
      return Math.min(this.currentPage * this.itemsPerPage, this.filteredClientes.length);
    },
  },
  mounted() {
    this.loadClientes();
  },
  watch: {
    filterStatus() { this.currentPage = 1; this.loadClientes(); },
    sortBy() { this.currentPage = 1; },
  },
  methods: {
    toTitleCase,
    // ========== WHATSAPP ==========
    abrirWhatsappCliente(cliente) {
      if (!cliente || !cliente.telefono) {
        this.mostrarAlerta({
          tipo: 'warning',
          titulo: 'Sin teléfono',
          mensaje: 'Este cliente no tiene número de teléfono registrado.'
        });
        return;
      }
      let cleanPhone = cliente.telefono.replace(/\D/g, '');
      if (cleanPhone.length === 10 && !cleanPhone.startsWith('58')) {
        cleanPhone = '58' + cleanPhone;
      } else if (cleanPhone.length === 11 && cleanPhone.startsWith('0')) {
        cleanPhone = '58' + cleanPhone.substring(1);
      }
      const nombre = formatearNombreCompleto(cliente.nombre, cliente.apellido) || 'Cliente';
      const mensaje = `Hola ${nombre}, le escribimos de Jean Informatico C.A.\n\nEstimado cliente, estamos a su disposición para cualquier consulta o servicio técnico.\n\nGracias por confiar en Jean Informatico C.A.`;
      window.open(`https://wa.me/${cleanPhone}?text=${encodeURIComponent(mensaje)}`, '_blank');
    },
    abrirWhatsappClienteSeleccionado() {
      if (this.selectedCliente) this.abrirWhatsappCliente(this.selectedCliente);
    },

    // ========== MÉTODOS DE CONFIRMACIÓN ==========
    abrirModalConfirmacion(config) {
      this.confirmModalTipo = config.tipo || 'confirm';
      this.confirmModalTitulo = config.titulo || 'Confirmar';
      this.confirmModalSubtitulo = config.subtitulo || '';
      this.confirmModalMensaje = config.mensaje || '¿Estás seguro?';
      this.confirmModalDetalle = config.detalle || '';
      this.confirmModalIcon = config.icon || 'mdi:help-circle';
      this.confirmModalColor = config.color || 'bg-gradient-to-r from-blue-600 to-indigo-600';
      this.confirmModalButtonColor = config.buttonColor || 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700';
      this.confirmModalBotonTexto = config.botonTexto || 'Confirmar';
      this.confirmModalCliente = config.cliente || null;
      this.confirmModalAccion = config.accion;
      this.confirmModalDatos = config.datos || null;
      this.showConfirmModal = true;
    },
    cancelarConfirmacion() {
      this.showConfirmModal = false;
      this.confirmModalCargando = false;
      this.confirmModalCliente = null;
      this.confirmModalAccion = null;
    },
    async ejecutarAccionConfirmada() {
      if (this.confirmModalAccion) {
        this.confirmModalCargando = true;
        await this.confirmModalAccion(this.confirmModalDatos);
        this.confirmModalCargando = false;
        this.cancelarConfirmacion();
      }
    },

    abrirModalEliminar(cliente) {
      const nombre = formatearNombreCompleto(cliente.nombre, cliente.apellido);
      this.abrirModalConfirmacion({
        tipo: 'eliminar',
        titulo: 'Eliminar Cliente',
        subtitulo: 'Esta acción no se puede deshacer',
        mensaje: `¿Eliminar a "${nombre}"?`,
        detalle: 'El cliente será eliminado permanentemente del sistema.',
        icon: 'mdi:alert-circle',
        color: 'bg-gradient-to-r from-red-600 to-pink-600',
        buttonColor: 'bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700',
        botonTexto: 'Eliminar',
        cliente: cliente,
        accion: () => this.deleteCliente(cliente.idCliente)
      });
    },

    abrirModalToggleStatus(cliente) {
      const esActivo = cliente.estado?.toLowerCase() === 'activo';
      const nombre = formatearNombreCompleto(cliente.nombre, cliente.apellido);
      this.abrirModalConfirmacion({
        tipo: 'toggle-status',
        titulo: esActivo ? 'Desactivar Cliente' : 'Activar Cliente',
        subtitulo: `Cambiar estado del cliente`,
        mensaje: `¿${esActivo ? 'desactivar' : 'activar'} a "${nombre}"?`,
        detalle: `Pasara de "${convertirEstadoATexto(cliente.estado)}" a "${convertirEstadoATexto(esActivo ? 'inactivo' : 'activo')}".`,
        icon: esActivo ? 'mdi:close-circle' : 'mdi:check-circle',
        color: esActivo ? 'bg-gradient-to-r from-red-600 to-orange-600' : 'bg-gradient-to-r from-green-600 to-emerald-600',
        buttonColor: esActivo ? 'bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700' : 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700',
        botonTexto: esActivo ? 'Desactivar' : 'Activar',
        cliente: cliente,
        accion: () => this.toggleStatus(cliente)
      });
    },

    // ========== CRUD ==========
    async loadClientes() {
      this.loading = true;
      try {
        let response;
        if (this.filterStatus === 'activos') response = await obtenerClientesActivos();
        else if (this.filterStatus === 'inactivos') response = await obtenerClientesPorEstado('inactivo');
        else if (this.searchQuery.trim()) response = await buscarClientesPorTermino(this.searchQuery);
        else response = await obtenerClientes();
        if (response.success) {
          this.clientes = response.data || [];
          this.lastUpdate = new Date();
          await this.fetchClientStats();
        }
      } catch (error) {
        console.error('Error al cargar clientes:', error);
      } finally {
        this.loading = false;
      }
    },

    async fetchClientStats() {
      if (this.clientes.length === 0) return;
      this.loadingStats = true;
      try {
        const clientsToFetch = this.paginatedClientes || [];
        const statsPromises = clientsToFetch.map(async (cliente) => {
          try {
            const [ventasRes, serviciosRes] = await Promise.all([
              obtenerVentasPorCliente(cliente.idCliente),
              obtenerRecepcionesPorCliente(cliente.idCliente)
            ]);
            const ventas = ventasRes.success ? ventasRes.data : [];
            const servicios = serviciosRes.success ? serviciosRes.data : [];
            const totalVentasMonto = ventas.reduce((sum, v) => sum + (v.totalUsd || v.total || 0), 0);
            return { idCliente: cliente.idCliente, totalVentasCount: ventas.length, totalVentasMonto, totalServiciosCount: servicios.length };
          } catch { return { idCliente: cliente.idCliente, totalVentasCount: 0, totalVentasMonto: 0, totalServiciosCount: 0 }; }
        });
        const statsResults = await Promise.all(statsPromises);
        this.clientes = this.clientes.map(cliente => {
          const stats = statsResults.find(s => s.idCliente === cliente.idCliente);
          return { ...cliente, stats: stats || cliente.stats || { totalVentasCount: 0, totalVentasMonto: 0, totalServiciosCount: 0 } };
        });
      } catch (error) {
        console.error('Error al cargar estadísticas:', error);
      } finally {
        this.loadingStats = false;
      }
    },

    async deleteCliente(id) {
      try {
        const result = await eliminarCliente(id);
        if (result.success) {
          await this.loadClientes();
          this.mostrarAlerta({ tipo: 'success', titulo: '¡Eliminado!', mensaje: 'Cliente eliminado correctamente' });
        }
      } catch (error) {
        console.error('Error al eliminar:', error);
        this.mostrarAlerta({ tipo: 'error', titulo: 'Error', mensaje: 'No se pudo eliminar el cliente' });
      }
    },

    async toggleStatus(cliente) {
      const esActivo = cliente.estado?.toLowerCase() === 'activo';
      try {
        const result = esActivo ? await desactivarCliente(cliente.idCliente) : await activarCliente(cliente.idCliente);
        if (result.success) {
          await this.loadClientes();
          this.mostrarAlerta({ tipo: 'success', titulo: '¡Estado cambiado!', mensaje: `Cliente ${esActivo ? 'desactivado' : 'activado'} correctamente` });
        }
      } catch (error) {
        console.error('Error al cambiar estado:', error);
        this.mostrarAlerta({ tipo: 'error', titulo: 'Error', mensaje: 'No se pudo cambiar el estado' });
      }
    },

    // ========== MODALES ==========
    openCreateModal() {
      this.editingCliente = null;
      this.form = { idCliente: null, tipoDocumento: 'cedula', documento: '', nombre: '', apellido: '', telefono: '', email: '', direccion: '', estado: 'activo' };
      this.showModal = true;
    },

    openEditModal(cliente) {
      this.editingCliente = cliente;
      this.form = { ...cliente };
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    openDetailModal(cliente) {
      this.selectedCliente = cliente;
      this.showDetailModal = true;
      this.activeDetailTab = 'general';
      this.selectedClientVentas = [];
      this.selectedClientServicios = [];
      this.fetchClientDetailedHistory(cliente.idCliente);
    },

    closeDetailModal() {
      this.showDetailModal = false;
      this.selectedCliente = null;
    },

    async fetchClientDetailedHistory(idCliente) {
      if (!idCliente) return;
      this.loadingDetails = true;
      try {
        const [ventasRes, serviciosRes] = await Promise.all([
          obtenerVentasPorCliente(idCliente),
          obtenerRecepcionesPorCliente(idCliente)
        ]);
        if (ventasRes.success) this.selectedClientVentas = ventasRes.data || [];
        if (serviciosRes.success) this.selectedClientServicios = serviciosRes.data || [];
      } catch (error) {
        console.error('Error al cargar historial:', error);
      } finally {
        this.loadingDetails = false;
      }
    },

    async saveCliente() {
      this.saving = true;
      try {
        let result;
        if (this.editingCliente) {
          result = await actualizarCliente(this.editingCliente.idCliente, this.form);
        } else {
          result = await crearCliente(this.form);
        }
        if (result.success) {
          await this.loadClientes();
          this.closeModal();
          this.mostrarAlerta({ tipo: 'success', titulo: this.editingCliente ? '¡Actualizado!' : '¡Creado!', mensaje: `Cliente ${this.editingCliente ? 'actualizado' : 'creado'} correctamente` });
        }
      } catch (error) {
        console.error('Error al guardar:', error);
        this.mostrarAlerta({ tipo: 'error', titulo: 'Error', mensaje: 'No se pudo guardar el cliente' });
      } finally {
        this.saving = false;
      }
    },

    // ========== EXPORTAR ==========
    async exportToExcel() {
      if (this.filteredClientes.length === 0) {
        this.mostrarAlerta({ tipo: 'warning', titulo: 'Sin datos', mensaje: 'No hay clientes para exportar' });
        return;
      }
      const result = exportarExcel(this.filteredClientes, 'clientes_jean_informatico');
      if (result.success) {
        this.mostrarAlerta({ tipo: 'success', titulo: '¡Exportado!', mensaje: `Archivo ${result.filename} generado` });
        this.showExportMenu = false;
      }
    },

    async exportToPDF() {
      if (this.filteredClientes.length === 0) {
        this.mostrarAlerta({ tipo: 'warning', titulo: 'Sin datos', mensaje: 'No hay clientes para exportar' });
        return;
      }
      try {
        const logo = await import('@/assets/logo-jean.jpg');
        const result = exportarPDF(this.filteredClientes, 'Reporte de Clientes - Jean Informatico C.A.', logo.default);
        if (result.success) {
          this.mostrarAlerta({ tipo: 'success', titulo: '¡Exportado!', mensaje: `PDF ${result.filename} generado` });
          this.showExportMenu = false;
        }
      } catch (error) {
        console.error('Error exportando PDF:', error);
        this.mostrarAlerta({ tipo: 'error', titulo: 'Error', mensaje: 'No se pudo generar el PDF' });
      }
    },

    async exportEmpresasToExcel() {
      const empresas = this.filteredClientes.filter(c => c.tipoDocumento === 'rif');
      if (empresas.length === 0) {
        this.mostrarAlerta({ tipo: 'warning', titulo: 'Sin empresas', mensaje: 'No hay clientes con RIF' });
        return;
      }
      const result = exportarExcel(empresas, 'clientes_empresas');
      if (result.success) {
        this.mostrarAlerta({ tipo: 'success', titulo: '¡Exportado!', mensaje: `Archivo ${result.filename} generado` });
        this.showExportMenu = false;
      }
    },

    async exportEmpresasToPDF() {
      const empresas = this.filteredClientes.filter(c => c.tipoDocumento === 'rif');
      if (empresas.length === 0) {
        this.mostrarAlerta({ tipo: 'warning', titulo: 'Sin empresas', mensaje: 'No hay clientes con RIF' });
        return;
      }
      try {
        const logo = await import('@/assets/logo-jean.jpg');
        const result = exportarPDF(empresas, 'Reporte de Empresas - Jean Informatico C.A.', logo.default);
        if (result.success) {
          this.mostrarAlerta({ tipo: 'success', titulo: '¡Exportado!', mensaje: `PDF ${result.filename} generado` });
          this.showExportMenu = false;
        }
      } catch (error) {
        console.error('Error exportando PDF empresas:', error);
        this.mostrarAlerta({ tipo: 'error', titulo: 'Error', mensaje: 'No se pudo generar el PDF' });
      }
    },

    async exportFullReport() {
      if (this.filteredClientes.length === 0) {
        this.mostrarAlerta({ tipo: 'warning', titulo: 'Sin datos', mensaje: 'No hay clientes para exportar' });
        return;
      }
      try {
        const logo = await import('@/assets/logo-jean.jpg');
        const empresas = this.filteredClientes.filter(c => c.tipoDocumento === 'rif');
        const resultExcel = exportarExcel(this.filteredClientes, 'reporte_completo_clientes');
        const resultPDF = exportarPDF(empresas, 'Reporte de Empresas - Jean Informatico C.A.', logo.default);
        if (resultExcel.success && resultPDF.success) {
          this.mostrarAlerta({ tipo: 'success', titulo: '¡Reportes generados!', mensaje: 'Excel y PDF generados correctamente' });
          this.showExportMenu = false;
        }
      } catch (error) {
        console.error('Error generando reporte completo:', error);
        this.mostrarAlerta({ tipo: 'error', titulo: 'Error', mensaje: 'No se pudieron generar los reportes' });
      }
    },

    triggerImportEmpresas() {
      this.$refs.importFile?.click();
    },

    async handleImportFile(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      try {
        const XLSX = require('xlsx');
        const data = await file.arrayBuffer();
        const workbook = XLSX.read(data, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        const empresas = rows.filter(r => {
          const doc = (r['Documento'] || r['RIF'] || r['rif'] || r['documento'] || '').toString();
          return /^[JGVE]-?\d{7,8}-?\d?$/.test(doc.replace(/\s+/g, '').toUpperCase());
        });
        if (empresas.length === 0) {
          this.mostrarAlerta({ tipo: 'warning', titulo: 'Sin empresas', mensaje: 'No se encontraron filas con RIF' });
          return;
        }
        this.loading = true;
        let creados = 0, saltados = 0;
        for (const row of empresas) {
          const documento = (row['Documento'] || row['RIF'] || row['rif'] || row['documento'] || '').toString().trim();
          if (!documento) { saltados++; continue; }
          const existRes = await verificarClientePorDocumento(documento);
          if (existRes.success && existRes.existe) { saltados++; continue; }
          const clienteData = {
            tipoDocumento: 'rif',
            documento,
            nombre: (row['Nombre'] || row['Razón Social'] || row['RazonSocial'] || row['nombre'] || '').toString().trim() || 'Empresa',
            apellido: '',
            telefono: (row['Teléfono'] || row['Telefono'] || row['telefono'] || '').toString().trim(),
            email: (row['Email'] || row['Correo'] || row['correo'] || row['email'] || '').toString().trim(),
            direccion: (row['Dirección'] || row['Direccion'] || row['direccion'] || '').toString().trim(),
            estado: 'activo'
          };
          const res = await crearCliente(clienteData);
          if (res.success) creados++; else saltados++;
        }
        this.mostrarAlerta({ tipo: 'success', titulo: 'Importación completada', mensaje: `${creados} creados, ${saltados} saltados` });
        await this.loadClientes();
      } catch (error) {
        console.error('Error importando empresas:', error);
        this.mostrarAlerta({ tipo: 'error', titulo: 'Error', mensaje: 'Error al importar el archivo' });
      } finally {
        this.loading = false;
        if (this.$refs.importFile) this.$refs.importFile.value = null;
      }
    },

    // ========== DETALLES DE VENTAS Y SERVICIOS ==========
    async irAVenta(idVenta) {
      this.selectedVentaDetail = null;
      this.showVentaDetailModal = true;
      this.loadingVentaDetail = true;
      try {
        const res = await obtenerVentaConRelaciones(idVenta);
        if (res.success && res.data) {
          this.selectedVentaDetail = res.data;
        }
      } catch (error) {
        console.error('Error al cargar detalle de venta:', error);
        this.showVentaDetailModal = false;
      } finally {
        this.loadingVentaDetail = false;
      }
    },

    async irAServicio(idServicio) {
      this.selectedServicioDetail = null;
      this.showServicioDetailModal = true;
      this.loadingServicioDetail = true;
      try {
        const res = await obtenerRecepcionConRelaciones(idServicio);
        if (res.success && res.data) {
          this.selectedServicioDetail = res.data;
        }
      } catch (error) {
        console.error('Error al cargar detalle de servicio:', error);
        this.showServicioDetailModal = false;
      } finally {
        this.loadingServicioDetail = false;
      }
    },

    // ========== UTILIDADES ==========
    formatCurrency(value) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value || 0);
    },
    formatDate(fechaISO) {
      if (!fechaISO) return '';
      try { return new Date(fechaISO).toLocaleDateString('es-VE', { year: 'numeric', month: '2-digit', day: '2-digit' }); }
      catch { return fechaISO; }
    },
    formatTime(fechaISO) {
      if (!fechaISO) return '';
      try { return new Date(fechaISO).toLocaleTimeString('es-VE', { hour: '2-digit', minute: '2-digit', hour12: false }); }
      catch { return ''; }
    },
    formatearTipoDocumento,
    convertirEstadoATexto,
    formatearNombreCompleto,
    formatearTelefono() {
      const formateado = formatearTelefonoVenezolano(this.form.telefono);
      if (formateado !== this.form.telefono) this.form.telefono = formateado;
    },
    formatearDocumentoInput() {
      if (this.form.tipoDocumento === 'cedula') {
        const formateado = formatearCedulaVenezolana(this.form.documento);
        if (formateado !== this.form.documento) this.form.documento = formateado;
      } else if (this.form.tipoDocumento === 'rif') {
        const formateado = formatearRIFVenezolano(this.form.documento);
        if (formateado !== this.form.documento) this.form.documento = formateado;
      }
    },
    getMaxLengthDocumento() {
      switch (this.form.tipoDocumento) {
        case 'cedula': return 15;
        case 'rif': return 12;
        default: return 20;
      }
    },
    getPlaceholderDocumento() {
      switch (this.form.tipoDocumento) {
        case 'cedula': return 'Ej: V-3175781';
        case 'rif': return 'Ej: J-12345678-9';
        default: return 'Ingrese el documento';
      }
    },
    handleTipoDocumentoChange() {
      this.form.documento = '';
    },
    handleSearch: debounce(function() {
      this.currentPage = 1;
      this.loadClientes();
    }, 300),
    handleFilterChange() {
      this.currentPage = 1;
      this.loadClientes();
    },
    clearFilters() {
      this.searchQuery = '';
      this.filterStatus = 'all';
      this.currentPage = 1;
      this.loadClientes();
    },
    mostrarAlerta(config) {
      // Usar SweetAlert2 o un sistema de alertas simple
      console.log('Alerta:', config);
      // Implementar con SweetAlert2 si está disponible
    },
  },
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }
.custom-scrollbar::-webkit-scrollbar { height: 6px; width: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; }

@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeInUp { animation: fadeInUp 0.4s ease-out forwards; }
.delay-100 { animation-delay: 0.1s; }
.delay-200 { animation-delay: 0.2s; }
.delay-300 { animation-delay: 0.3s; }

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeIn { animation: fadeIn 0.3s ease-out forwards; }

@keyframes slideInFromBottom {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
.slide-in-from-bottom-2 { animation: slideInFromBottom 0.3s ease-out forwards; }

@media (max-width: 768px) {
  button { min-height: 44px; }
  input, select, textarea { font-size: 16px !important; }
}
</style>